import { MatterNS, MatterSchema } from "@smart/bridge-types-basic";
import { buildTableDef } from "@smart/itops-constructs-basic";
import { wrapSchema } from "@smart/itops-utils-basic";

const matterGuard = wrapSchema(MatterSchema);

export const MatterDef = buildTableDef(
  {
    namespace: MatterNS,
    guard: matterGuard,
    keyFields: ["uri"],
    keySchema: { uri: "string" },
    ttlField: "deletedAtSec",
  } as const,
  {} as const,
);
